export const get_auth_cookie = () => {
    var cookies = require("vue-cookies");
    var CryptoJS = require("crypto-js");
    var auth_cookie = cookies.get('auth_token');
    if(auth_cookie){
        var token = CryptoJS.AES.decrypt(auth_cookie.replace(/['"]+/g, ''),
            CryptoJS.enc.Utf8.parse(CryptoJS.SHA256(process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString().substring(0, 32)), {
            iv: CryptoJS.enc.Utf8.parse(CryptoJS.SHA256(process.env.VUE_APP_ENCRYPTION_IV).toString().substring(0, 16)),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        token = CryptoJS.enc.Utf8.stringify(token);
        return token;
    }
    else{
        return '';
    }
};

export const get_refresh_cookie = () => {
    var cookies = require("vue-cookies");
    var CryptoJS = require("crypto-js");
    var r_token = cookies.get('r_token');
    if(r_token){
        r_token = CryptoJS.AES.decrypt(r_token.replace(/['"]+/g, ''),
            CryptoJS.enc.Utf8.parse(CryptoJS.SHA256(process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString().substring(0, 32)), {
            iv: CryptoJS.enc.Utf8.parse(CryptoJS.SHA256(process.env.VUE_APP_ENCRYPTION_IV).toString().substring(0, 16)),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        r_token = CryptoJS.enc.Utf8.stringify(r_token);
        return r_token;
    }
    else{
        return '';
    }
};

export const remove_auth_cookie = () => {
    var cookies = require("vue-cookies");
    cookies.remove("auth_token", null, process.env.VUE_APP_AUTH_COOKIE_DOMAIN);
    cookies.remove("Client", null, process.env.VUE_APP_AUTH_COOKIE_DOMAIN);
    cookies.remove("Client");
    cookies.remove("r_token", null, process.env.VUE_APP_AUTH_COOKIE_DOMAIN);
    cookies.remove("r_token");
};

export const set_auth_cookie = (token) => {
    var cookies = require("vue-cookies");
    var CryptoJS = require("crypto-js");
    token = CryptoJS.AES.encrypt(token,
        CryptoJS.enc.Utf8.parse(CryptoJS.SHA256(process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString().substring(0, 32)), {
        iv: CryptoJS.enc.Utf8.parse(CryptoJS.SHA256(process.env.VUE_APP_ENCRYPTION_IV).toString().substring(0, 16)),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    cookies.set("auth_token", '"' + token.toString() + '"', process.env.VUE_APP_ACCESS_TOKEN_LIFETIME, null, process.env.VUE_APP_AUTH_COOKIE_DOMAIN);
};

export const get_cookie = (name) => {
    var cookies = require("vue-cookies");
    var cookie = cookies.get(name);
    return cookie
};